import { render } from "./SocialPosts.vue?vue&type=template&id=f4ad4a3c&scoped=true"
import script from "./SocialPosts.vue?vue&type=script&lang=js"
export * from "./SocialPosts.vue?vue&type=script&lang=js"

import "./SocialPosts.vue?vue&type=style&index=0&id=f4ad4a3c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ad4a3c"]])

export default __exports__